import { Card, CardContent } from "@/components/ui/card";
import { format } from "date-fns";

interface StatsCardProps {
  totalMessages: number;
  uniqueWords: number;
  dateRange: { start: string | null; end: string | null };
  isLoading?: boolean;
}

export function StatsCard({
  totalMessages,
  uniqueWords,
  dateRange,
  isLoading,
}: StatsCardProps) {
  const formatDateRange = () => {
    if (!dateRange.start && !dateRange.end) {
      return "All time";
    }
    if (dateRange.start && !dateRange.end) {
      return `Since ${format(new Date(dateRange.start), "MMM dd, yyyy")}`;
    }
    if (!dateRange.start && dateRange.end) {
      return `Until ${format(new Date(dateRange.end), "MMM dd, yyyy")}`;
    }
    return `${format(new Date(dateRange.start!), "MMM dd, yyyy")} - ${format(new Date(dateRange.end!), "MMM dd, yyyy")}`;
  };

  if (isLoading) {
    return (
      <Card className="animate-pulse">
        <CardContent className="p-6">
          <div className="grid grid-cols-3 gap-4">
            <div className="h-20 rounded bg-gray-200" />
            <div className="h-20 rounded bg-gray-200" />
            <div className="h-20 rounded bg-gray-200" />
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="p-6">
        <div className="grid grid-cols-3 gap-4">
          <div className="flex flex-col">
            <div className="text-sm text-gray-600">Total Messages</div>
            <div className="text-3xl font-semibold text-gray-900">
              {totalMessages.toLocaleString("en-US")}
            </div>
          </div>

          <div className="flex flex-col">
            <div className="text-sm text-gray-600">Unique Words</div>
            <div className="text-3xl font-semibold text-gray-900">
              {uniqueWords.toLocaleString("en-US")}
            </div>
          </div>

          <div className="flex flex-col">
            <div className="text-sm text-gray-600">Date Range</div>
            <div className="text-lg font-medium text-gray-900">
              {formatDateRange()}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
